/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Collapse,
  IconButton,
  TableRow,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PhoneIcon from '@material-ui/icons/Phone';
import ReplayIcon from '@material-ui/icons/Replay';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import EmailIcon from '@material-ui/icons/Email';
import { storeContext } from '../provider/Provider';
import { leadsActions } from '../../store/leads-reducer';
import BlueButton from '../../customUI/BlueButton';
import { StyledTableCell, StyledTableCellCollapse } from '../../customUI/table/TableStyles';

import { formatPhoneNumber } from '../../functions';
import RedButton from '../../customUI/RedButton';

const useStyles = makeStyles(() => ({
  blackLink: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
  },
  squareButton: {
    borderRadius: 4,
  },
  arrowButton: {
    padding: 0,
    marginLeft: 0,
    marginRight: 6,
  },
}));

const { REACT_APP_HIDE_SPAM } = process.env;

const LeadsTableRow = ({ row, pageNumber, rowsPerPage, rowNumber, leadId, handleLeadClick, handleLeadSpamClick, handleDeleteClick, handleLeadRowClick }) => {
  const classes = useStyles();
  const { dispatch } = useContext(storeContext);
  const [open, setOpen] = useState(false);


  const [phone] = useState(row.leadBody.phone);


	
  const handleAddLead = () => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleLeadClick();
  };

  const handleMarkSpam = () => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleLeadSpamClick();
  };

  const handleDelete = () => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentLead: row,
      },
    });
    handleLeadRowClick(row.uuid);
    handleDeleteClick();
  };
  

  return (
    <>
      <TableRow key={row.leadBody.email} style={leadId === row.uuid? {background: "#d9edf7"}: {background: "white"}}>
        <StyledTableCell>
          {(rowNumber + 1) + (pageNumber * rowsPerPage)}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row">
          {`${new Date(row.createdAt).toLocaleString('en-US', { timeZone: 'UTC', year: 'numeric', month: 'short', day: '2-digit' })}`}
        </StyledTableCell>
        <StyledTableCell>
          <IconButton
            aria-label="expand row"
            className={classes.arrowButton}
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open ? (
              <KeyboardArrowUpIcon style={{ fontSize: 'medium' }} />
            ) : (
              <KeyboardArrowDownIcon style={{ fontSize: 'medium' }} />
            )}
          </IconButton>
          {row.leadBody.fullName}
        </StyledTableCell>
				<StyledTableCell component="th" scope="row" style={{ background: 'rgba(214, 255, 212, 0.3)'}}>
          {phone && phone !== '' && <> 
            <PhoneIcon style={{ fontSize: 'small', marginRight: 5 }} />
            {formatPhoneNumber(phone)} 
          </>} 
          
        </StyledTableCell>
        <StyledTableCell component="th" scope="row" style={{ background: 'rgba(0, 180, 224, 0.1)'}}>
          <a className={classes.blackLink} href={`mailto:${row.leadBody.email}`}>
            {row.leadBody.email}
          </a>
        </StyledTableCell>
        <StyledTableCell style={{ background: 'rgba(0, 180, 224, 0.1)', textAlign: 'center'}}>
          {!row.leadBody.chat && (
            <IconButton
              aria-label="expand row form"
              className={classes.arrowButton}
              onClick={() => setOpen(!open)}
            >
                <EmailIcon style={{ fontSize: 'large' }} />
            </IconButton>
          )}
        </StyledTableCell>
        <StyledTableCell style={{ minWidth: 150 }} align="center">
        	{!row.is_spam ? <BlueButton
            style={{fontSize: "1rem"}}
						aria-label="convert opportunity to lead"
						onClick={handleAddLead}
					>
						Add Lead
					</BlueButton> : <RedButton
            style={{
              fontSize: "1rem",
              borderRadius: '5px',
              padding: '3px 10px',
              width: '120px',
            }}
            onClick={handleDelete}
          >
            <DeleteIcon 
              style={{ fontSize: 'medium', marginRight: 5 }} 
            />
						Delete
					</RedButton>}
          {REACT_APP_HIDE_SPAM === "false" && (row.is_spam? (<RedButton
            style={{
              fontSize: "1rem",
              borderRadius: '5px',
              padding: '3px 10px',
              width: '120px',
            }}
            onClick={handleMarkSpam}
          >
            <ReplayIcon 
              style={{
                fontSize: 'medium', 
                marginRight: 5,
              }}
            />
						Spam
					</RedButton>):
          (<BlueButton
            style={{
              fontSize: '1rem',
              width: '120px',
              padding: '0 20px',
            }}
						aria-label="Set spam flag for form"
						onClick={handleMarkSpam}
					>
						Mark Spam
					</BlueButton>))}
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCellCollapse style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {Object.entries(row.leadBody).map(([key, value]) => {
              if (typeof value !== 'object') {
                return (
                  <React.Fragment key={row.uuid + value}>
                    <strong>{key}: </strong>
                    <span style={{ wordBreak: value && value.split(" ") &&  value.split(" ")[0]?.length > 120? 'break-all': 'initial' }}>{value}</span>
                    <br />
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </Collapse>
        </StyledTableCellCollapse>
        </TableRow>
    </>
  );
};

export default LeadsTableRow;
